var map = {
	"./$pac.svg": "2a03",
	"./0xbtc.svg": "5cbf",
	"./2give.svg": "5e72",
	"./abt.svg": "60ec",
	"./act.svg": "08ca",
	"./actn.svg": "8cc9",
	"./ada.svg": "dd16",
	"./add.svg": "47d9",
	"./adx.svg": "e3e9",
	"./ae.svg": "e854",
	"./aeon.svg": "f413",
	"./aeur.svg": "6883",
	"./agi.svg": "433f",
	"./agrs.svg": "4275",
	"./aion.svg": "0874",
	"./aiv.svg": "8828",
	"./algo.svg": "a90b",
	"./amb.svg": "6ede",
	"./amp.svg": "a811",
	"./ampl.svg": "e3a6",
	"./ant.svg": "ef66",
	"./apex.svg": "8367",
	"./appc.svg": "0855",
	"./ardr.svg": "68f2",
	"./arg.svg": "1d6c",
	"./ark.svg": "d224",
	"./arn.svg": "e359",
	"./arnx.svg": "d60ae",
	"./ary.svg": "b7cd",
	"./ast.svg": "0a75",
	"./atm.svg": "f2d8",
	"./atom.svg": "82a3",
	"./audr.svg": "3a09",
	"./auto.svg": "72e3",
	"./aywa.svg": "e9cc",
	"./bab.svg": "2172",
	"./bal.svg": "b6710",
	"./band.svg": "b7fc",
	"./bat.svg": "6082",
	"./bay.svg": "5b17",
	"./bcbc.svg": "3521",
	"./bcc.svg": "30b6",
	"./bcd.svg": "7c0d",
	"./bch.svg": "be2a",
	"./bcio.svg": "641f",
	"./bcn.svg": "da65",
	"./bco.svg": "af73",
	"./bcpt.svg": "a15e",
	"./bdl.svg": "bd0f",
	"./beam.svg": "c82f",
	"./bela.svg": "1620",
	"./bix.svg": "795a",
	"./blcn.svg": "4347",
	"./blk.svg": "f0a7",
	"./block.svg": "e399",
	"./blz.svg": "acccc",
	"./bnb.svg": "f9c3",
	"./bnt.svg": "476e",
	"./bnty.svg": "c82c1",
	"./booty.svg": "8918",
	"./bos.svg": "8ad5",
	"./bpt.svg": "e8c6",
	"./bq.svg": "140b",
	"./brd.svg": "bcf1",
	"./bsd.svg": "bd86",
	"./bsv.svg": "5b6f",
	"./btc.svg": "4d4b",
	"./btcd.svg": "22fd",
	"./btch.svg": "6a7c",
	"./btcp.svg": "aac6",
	"./btcz.svg": "79c2",
	"./btdx.svg": "e8fa",
	"./btg.svg": "75f8",
	"./btm.svg": "3d6a",
	"./bts.svg": "63b8",
	"./btt.svg": "1f22",
	"./btx.svg": "0f44",
	"./burst.svg": "a481",
	"./bze.svg": "93d3",
	"./call.svg": "72ab",
	"./cc.svg": "445a",
	"./cdn.svg": "5c77",
	"./cdt.svg": "9c70",
	"./cenz.svg": "310b",
	"./chain.svg": "33ae",
	"./chat.svg": "05e8",
	"./chips.svg": "b0d8",
	"./cix.svg": "b0d4",
	"./clam.svg": "84f1",
	"./cloak.svg": "8dd5",
	"./cmm.svg": "0a94",
	"./cmt.svg": "395f",
	"./cnd.svg": "aeec",
	"./cnx.svg": "4c56",
	"./cny.svg": "1e6a",
	"./cob.svg": "7896",
	"./colx.svg": "0c1e",
	"./comp.svg": "4845",
	"./coqui.svg": "2235",
	"./cred.svg": "0ad7",
	"./crpt.svg": "7a7f",
	"./crw.svg": "0e70",
	"./cs.svg": "c112",
	"./ctr.svg": "2e4bc",
	"./ctxc.svg": "7b43",
	"./cvc.svg": "c4c7",
	"./d.svg": "6d50",
	"./dai.svg": "63cd",
	"./dash.svg": "6d44",
	"./dat.svg": "05f1",
	"./data.svg": "2433",
	"./dbc.svg": "3979",
	"./dcn.svg": "30d8",
	"./dcr.svg": "98b3",
	"./deez.svg": "5dc2",
	"./dent.svg": "2d9d",
	"./dew.svg": "9f5e",
	"./dgb.svg": "650b",
	"./dgd.svg": "fb23",
	"./dlt.svg": "9402",
	"./dnt.svg": "da87",
	"./dock.svg": "48ed",
	"./doge.svg": "55c6",
	"./dot.svg": "01ea",
	"./drgn.svg": "6070",
	"./drop.svg": "9211",
	"./dta.svg": "2b97",
	"./dth.svg": "3282",
	"./dtr.svg": "64aa",
	"./ebst.svg": "dbfc",
	"./eca.svg": "fa7a",
	"./edg.svg": "0216",
	"./edo.svg": "7542",
	"./edoge.svg": "5375",
	"./ela.svg": "5d1a",
	"./elec.svg": "45fd",
	"./elf.svg": "941f",
	"./elix.svg": "0cd8",
	"./ella.svg": "23b9",
	"./emc.svg": "3c01",
	"./emc2.svg": "d440",
	"./eng.svg": "e9a3",
	"./enj.svg": "5178",
	"./entrp.svg": "cb97",
	"./eon.svg": "153c",
	"./eop.svg": "bb10",
	"./eos.svg": "34ed",
	"./eqli.svg": "8567",
	"./equa.svg": "6637",
	"./etc.svg": "03ac",
	"./eth.svg": "4295",
	"./ethos.svg": "d5d2",
	"./etn.svg": "7623",
	"./etp.svg": "cc07",
	"./eur.svg": "7595",
	"./evx.svg": "06d2",
	"./exmo.svg": "c3a9",
	"./exp.svg": "83fc",
	"./fair.svg": "c92e",
	"./fct.svg": "4af7",
	"./fil.svg": "594f",
	"./fjc.svg": "f76b",
	"./fldc.svg": "bf08",
	"./flo.svg": "e6be",
	"./fsn.svg": "6570",
	"./ftc.svg": "01dc",
	"./fuel.svg": "fc2f",
	"./fun.svg": "e535",
	"./game.svg": "2846",
	"./gas.svg": "942a",
	"./gbp.svg": "5257",
	"./gbx.svg": "6944",
	"./gbyte.svg": "b0fc",
	"./generic.svg": "af2d",
	"./gin.svg": "e749",
	"./glxt.svg": "0dbc",
	"./gmr.svg": "c0a4",
	"./gno.svg": "c584",
	"./gnt.svg": "82a8",
	"./gold.svg": "0d02",
	"./grc.svg": "fab3",
	"./grin.svg": "6735",
	"./grs.svg": "064a",
	"./gsc.svg": "51fc",
	"./gto.svg": "e7fa",
	"./gup.svg": "3404",
	"./gusd.svg": "bdcf",
	"./gvt.svg": "9a91",
	"./gxs.svg": "9c27",
	"./gzr.svg": "b37a",
	"./hight.svg": "ccbd",
	"./hodl.svg": "6c64",
	"./hot.svg": "1fee",
	"./hpb.svg": "e120",
	"./hsr.svg": "ec63",
	"./ht.svg": "958d",
	"./html.svg": "7068",
	"./huc.svg": "5c04",
	"./hush.svg": "56aa",
	"./icn.svg": "33ca",
	"./icx.svg": "969f",
	"./ignis.svg": "1787",
	"./ilk.svg": "c75e",
	"./ink.svg": "2327",
	"./ins.svg": "7dea",
	"./ion.svg": "6ba3",
	"./iop.svg": "1237",
	"./iost.svg": "8e29",
	"./iotx.svg": "b0e5",
	"./iq.svg": "47a0",
	"./itc.svg": "0961",
	"./jnt.svg": "a862",
	"./jpy.svg": "1259",
	"./kcs.svg": "9a2f",
	"./kin.svg": "cde2",
	"./klown.svg": "863c",
	"./kmd.svg": "75a1",
	"./knc.svg": "e7ff",
	"./krb.svg": "2675",
	"./lbc.svg": "e29b",
	"./lend.svg": "f79e",
	"./leo.svg": "d0db",
	"./link.svg": "da7b",
	"./lkk.svg": "3be6",
	"./loom.svg": "777e",
	"./lpt.svg": "e34b",
	"./lrc.svg": "e47c",
	"./lsk.svg": "88ee",
	"./ltc.svg": "0090",
	"./lun.svg": "1555",
	"./maid.svg": "018c",
	"./mana.svg": "941f8",
	"./matic.svg": "6f62",
	"./mcap.svg": "d72e",
	"./mco.svg": "e56c",
	"./mda.svg": "7497",
	"./mds.svg": "3d9a",
	"./med.svg": "64b5",
	"./meetone.svg": "dd2d",
	"./mft.svg": "bfd1",
	"./miota.svg": "382a",
	"./mith.svg": "39b5",
	"./mkr.svg": "dbf3",
	"./mln.svg": "6ad3",
	"./mnx.svg": "6f29",
	"./mnz.svg": "4778",
	"./moac.svg": "6d87",
	"./mod.svg": "d5a8",
	"./mona.svg": "da7e",
	"./msr.svg": "50a0",
	"./mth.svg": "708f",
	"./mtl.svg": "8265",
	"./music.svg": "f539",
	"./mzc.svg": "f33e",
	"./nano.svg": "4826",
	"./nas.svg": "7502",
	"./nav.svg": "b0af7",
	"./ncash.svg": "8139",
	"./ndz.svg": "71e8",
	"./nebl.svg": "aaab",
	"./neo.svg": "85d60",
	"./neos.svg": "59b2",
	"./neu.svg": "5f1c",
	"./nexo.svg": "d6d7",
	"./ngc.svg": "98f5",
	"./nio.svg": "7d06",
	"./nlc2.svg": "02b4",
	"./nlg.svg": "5ca3",
	"./nmc.svg": "2867",
	"./nmr.svg": "723a",
	"./npxs.svg": "4d15",
	"./nuls.svg": "398c",
	"./nxs.svg": "606f",
	"./nxt.svg": "0bd9",
	"./oax.svg": "dc1b",
	"./ok.svg": "d36e",
	"./omg.svg": "3a48",
	"./omni.svg": "52c8",
	"./ong.svg": "8225",
	"./ont.svg": "d0cd",
	"./oot.svg": "6cda",
	"./ost.svg": "e4dd",
	"./ox.svg": "87b4",
	"./oxt.svg": "53f1",
	"./part.svg": "cf27",
	"./pasc.svg": "70dc",
	"./pasl.svg": "0882",
	"./pax.svg": "3f66",
	"./pay.svg": "9c11",
	"./payx.svg": "24c5",
	"./pink.svg": "2a93",
	"./pirl.svg": "f7f0",
	"./pivx.svg": "b9b3",
	"./plr.svg": "7ea1",
	"./poa.svg": "0308",
	"./poe.svg": "b441",
	"./polis.svg": "10b2",
	"./poly.svg": "0576",
	"./pot.svg": "1dcf",
	"./powr.svg": "24c9",
	"./ppc.svg": "8eb3",
	"./ppp.svg": "0abe",
	"./ppt.svg": "4f31",
	"./pre.svg": "2447",
	"./prl.svg": "95b6",
	"./pungo.svg": "bb16",
	"./pura.svg": "4b5b",
	"./qash.svg": "bbcd",
	"./qiwi.svg": "c27e",
	"./qlc.svg": "a5bb",
	"./qrl.svg": "7a32",
	"./qsp.svg": "1f41",
	"./qtum.svg": "f357",
	"./r.svg": "1b2a",
	"./rads.svg": "040d",
	"./rap.svg": "ba7e",
	"./rcn.svg": "b02d",
	"./rdd.svg": "fea4",
	"./rdn.svg": "7aca",
	"./ren.svg": "4c6b",
	"./rep.svg": "12be",
	"./repv2.svg": "9a01",
	"./req.svg": "c499",
	"./rhoc.svg": "f489",
	"./ric.svg": "123d",
	"./rise.svg": "4398",
	"./rlc.svg": "9af1",
	"./rpx.svg": "5234",
	"./rub.svg": "24ce",
	"./rvn.svg": "f4ee",
	"./ryo.svg": "2398",
	"./safe.svg": "a189",
	"./sai.svg": "7cfc",
	"./salt.svg": "9942",
	"./san.svg": "f422",
	"./sbd.svg": "9976",
	"./sberbank.svg": "6897",
	"./sc.svg": "4bf3",
	"./shift.svg": "96ca",
	"./sib.svg": "4a46",
	"./sin.svg": "0a37",
	"./sky.svg": "0283",
	"./slr.svg": "a398",
	"./sls.svg": "f912",
	"./smart.svg": "ee8f",
	"./sngls.svg": "845f",
	"./snm.svg": "2025",
	"./snt.svg": "7774",
	"./soc.svg": "36a1",
	"./spank.svg": "d362",
	"./sphtx.svg": "f0cc",
	"./srn.svg": "66ae",
	"./stak.svg": "8ca3",
	"./start.svg": "4aa7",
	"./steem.svg": "ed92",
	"./storj.svg": "eb61b",
	"./storm.svg": "e42e",
	"./stq.svg": "c8cb",
	"./strat.svg": "c130",
	"./stx.svg": "7384",
	"./sub.svg": "0b9e",
	"./sumo.svg": "d238",
	"./sys.svg": "7f88",
	"./taas.svg": "d87a",
	"./tau.svg": "1ccc",
	"./tbx.svg": "7cdc",
	"./tel.svg": "65c3",
	"./ten.svg": "4acf",
	"./tern.svg": "0698",
	"./tgch.svg": "1c2a",
	"./theta.svg": "2323",
	"./tix.svg": "04b2",
	"./tkn.svg": "0e6b4",
	"./tks.svg": "38e6",
	"./tnb.svg": "c7f0",
	"./tnc.svg": "b2708",
	"./tnt.svg": "ae61",
	"./tomo.svg": "c9af",
	"./tpay.svg": "0eac",
	"./trig.svg": "000f",
	"./trtl.svg": "af21",
	"./trx.svg": "2985",
	"./tusd.svg": "e305",
	"./tzc.svg": "767e",
	"./ubq.svg": "f197",
	"./uma.svg": "6de7",
	"./uni.svg": "c1a8",
	"./unity.svg": "5995",
	"./usd.svg": "f4bf",
	"./usdc.svg": "1521",
	"./usdt.svg": "8701",
	"./utk.svg": "27db",
	"./veri.svg": "fad4",
	"./vet.svg": "b206",
	"./via.svg": "bd8b",
	"./vib.svg": "b825",
	"./vibe.svg": "afe6",
	"./vivo.svg": "7c9f",
	"./vrc.svg": "c153",
	"./vrsc.svg": "6dff",
	"./vtc.svg": "5dcd",
	"./vtho.svg": "1ec8",
	"./wabi.svg": "ed98",
	"./wan.svg": "9cf4",
	"./waves.svg": "a80c",
	"./wax.svg": "8a1c",
	"./wbtc.svg": "bf88",
	"./wgr.svg": "4a5c",
	"./wicc.svg": "d13e",
	"./wings.svg": "ad48",
	"./wpr.svg": "6042",
	"./wtc.svg": "97c5",
	"./x.svg": "4338",
	"./xas.svg": "2324",
	"./xbc.svg": "1f5c",
	"./xbp.svg": "d116",
	"./xby.svg": "db293",
	"./xcp.svg": "6906",
	"./xdn.svg": "4aa3",
	"./xem.svg": "4cbe",
	"./xin.svg": "d48e",
	"./xlm.svg": "bb65",
	"./xmcc.svg": "6667",
	"./xmg.svg": "813c",
	"./xmo.svg": "a62c",
	"./xmr.svg": "c00b",
	"./xmy.svg": "8d7c",
	"./xp.svg": "c885",
	"./xpa.svg": "4cef",
	"./xpm.svg": "4dcd",
	"./xrp.svg": "4236",
	"./xsg.svg": "9459",
	"./xtz.svg": "1563",
	"./xuc.svg": "6276",
	"./xvc.svg": "6c63",
	"./xvg.svg": "62c4",
	"./xzc.svg": "7138",
	"./yfi.svg": "099f",
	"./yoyow.svg": "c759",
	"./zcl.svg": "b836",
	"./zec.svg": "9392",
	"./zel.svg": "842d",
	"./zen.svg": "108e",
	"./zest.svg": "1fac",
	"./zil.svg": "3b29",
	"./zilla.svg": "d56a",
	"./zrx.svg": "c179"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "315d";